import { PlatformDetectionService } from '@libs/util/shared';
import { StatusBarService } from './status-bar.service';

/**
 * Creates a new instance of {@link StatusBarService}. When running the application on a browser,
 * the service is mocked using a {@link Proxy}, so no operation will be executed.
 * This avoids console errors on browser.
 * @param platformDetectionService The dependent service
 */
export function statusBarServiceFactory(platformDetectionService: PlatformDetectionService): StatusBarService {
  const instance = new StatusBarService();

  if (platformDetectionService.isMobile()) {
    return instance;
  }

  const handler = {
    get() {
      return () => Promise.resolve();
    },
  };

  return new Proxy(instance, handler);
}
